import React, { useEffect, useState } from 'react';
import { Container, Header, Table, NoneContent } from './styled';
import Editor from './Editor';
import Viewer from './Viewer';
import { NamedCommunityService } from 'services/named';
import { useHistory } from 'react-router-dom';
import { Constants } from 'environment';
import ReCAPTCHA from 'react-google-recaptcha';
import useUsersStore from 'hooks/useUsersStore';
import useModalStore from 'hooks/useModalStore';

const Analysis = ({ gameId, sportsType }) => {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const wrId = query.get('wrId') || '';
  const fromBest = query.get('from_best') || '';

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  const [data, setData] = useState(null);
  const [viewForm, setViewForm] = useState(false);

  const recaptchaRef = React.useRef(null);

  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const userStore = useUsersStore();
  const modalStore = useModalStore();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (recaptchaRef.current) {
        setIsReady(true);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleRecaptchaVerify = async () => {
    if (!recaptchaRef.current || typeof recaptchaRef.current.executeAsync !== 'function') {
      console.warn('Recaptcha is not ready');
      return null;
    }

    try {
      recaptchaRef.current.reset();
      const token = await recaptchaRef.current.executeAsync();
      await new Promise((resolve) => setTimeout(resolve, 200)); // Wait briefly to ensure the token is fully processed before proceeding. This helps prevent "Uncaught (in promise) Timeout (B)" errors in some browsers or slow networks.
      return token;
    } catch (e) {
      console.error('reCAPTCHA failed:', e);
      return null;
    }
  };

  useEffect(() => {
    getAnalysisList();
  }, []);

  useEffect(() => {
    if (wrId) {
      NamedCommunityService.detail(wrId, 'sports_analysis', fromBest != '' ? fromBest : '0').then((res) => {
        if (res.code === 200) {
          setData(res.data);
        } else {
          alert(res.message);
          history.replace({
            search: '',
          });
        }
      });
    } else {
      setData(null);
    }
  }, [wrId]);

  const getDetail = async (wrId) => {
    NamedCommunityService.detail(wrId, 'sports_analysis', fromBest != '' ? fromBest : '0').then((res) => {
      if (res.code === 200) {
        setData(res.data);
      } else {
        alert(res.message);
        history.replace({
          search: '',
        });
      }
    });
  };

  const getAnalysisList = async () => {
    await NamedCommunityService.list({
      board_type: 'sports_analysis',
      game_id: gameId,
    }).then((res) => {
      if (res.code === 200) {
        setList(res.data.list);
      }
      setLoading(false);
    });
  };
  function handleWriteClick() {
    if (userStore.data.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return;
    }
    setViewForm(true);
  }


  const getBaseSubject = (homeTeam, awayTeam) => {
    if (!!homeTeam && !!awayTeam) {
      return `[${homeTeam} vs ${awayTeam}] `;
    }
    return '';
  };

  return (
    <Container>
      {!!data && <Viewer data={data} setData={setData} setViewForm={setViewForm} getDetail={getDetail} />}
      <div style={{ display: 'none' }}>
        <ReCAPTCHA
          ref={(el) => {
            recaptchaRef.current = el;
            setIsRecaptchaReady(!!el);
          }}
          sitekey={Constants._GOOGLE_CAPTCHA_INVISIBLE_SITEKEY}
          size='invisible'
          onErrored={() => {
            console.error('ReCAPTCHA failed to load or execute');
          }}
        />
      </div>
      <Editor
        data={data}
        setData={setData}
        gameId={gameId}
        view={viewForm}
        setView={setViewForm}
        getAnalysisList={getAnalysisList}
        isModify={!!wrId}
        sportsType={sportsType}
        recaptchaVerify={handleRecaptchaVerify}
      />
      <Header>
        <p>경기 분석글</p>
        <button onClick={() => handleWriteClick()}>글쓰기</button>
      </Header>
      <Table>
        <colgroup>
          <col width={'60%'} />
          <col width={'20%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <thead>
          <tr>
            <th>제목</th>
            <th>작성자</th>
            <th>조회</th>
            <th>추천</th>
          </tr>
        </thead>
        <tbody>
          {list.map((item, key) => {
            const { wr_subject, wr_name, wr_hit, wr_good, home_team, away_team } = item;
            return (
              <tr
                key={key}
                onClick={() => {
                  history.replace({
                    search: `wrId=${item.wr_id}`,
                  });
                }}
              >
                <td>
                  <p>{wr_subject}</p>
                </td>
                <td>{wr_name}</td>
                <td>{wr_hit}</td>
                <td>{wr_good}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {list.length === 0 && !loading && (
        <NoneContent>
          <p>작성된 분석글이 없습니다.</p>
        </NoneContent>
      )}
    </Container>
  );
};

export default Analysis;
